import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/* eslint-disable react/jsx-fragments */


import React, { Component } from 'react';
import qs from 'qs';
import Campaign from '../Campaign';
import Text from './DefaultText';
import ShareButtons from './ShareButtons';

var Content = function Content(props) {
  var resourceType = props.pageContext.node.resourceType,
      location = props.location;

  var _qs$parse = qs.parse(location.search.replace('?', '')),
      transactionStatus = _qs$parse.transaction_status;

  return React.createElement(React.Fragment, null, React.createElement(Text, {
    resourceType: resourceType,
    transactionStatus: transactionStatus
  }), React.createElement(ShareButtons, props));
};

var Main =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Main, _Component);

  function Main() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.childProps = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

      return Object.assign({}, props, {}, _this.props.childProps);
    };

    _this.children = function (children) {
      if (children === void 0) {
        children = _this.props.children;
      }

      var props = _this.childProps();

      return React.Children.map(children, function (element) {
        return React.cloneElement(element, props);
      });
    };

    return _this;
  }

  var _proto = Main.prototype;

  _proto.render = function render() {
    return React.createElement(Campaign.Content, this.props, this.children());
  };

  return Main;
}(Component);

Main.defaultProps = {
  children: [React.createElement(Content, null)]
};

var CampaignConfirmed =
/*#__PURE__*/
function (_Component2) {
  _inheritsLoose(CampaignConfirmed, _Component2);

  function CampaignConfirmed() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = CampaignConfirmed.prototype;

  _proto2.render = function render() {
    return React.createElement(Campaign, this.props);
  };

  return CampaignConfirmed;
}(Component);

CampaignConfirmed.Navigation = Campaign.Navigation;
CampaignConfirmed.Text = Text;
CampaignConfirmed.ShareButtons = ShareButtons;
CampaignConfirmed.Content = Content;
CampaignConfirmed.Main = Main;
CampaignConfirmed.defaultProps = {
  children: [React.createElement(CampaignConfirmed.Navigation, null), React.createElement(CampaignConfirmed.Main, null)]
};
export { CampaignConfirmed as default };